var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEformv2CreateBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#A614B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7575 11.0098C7.34328 11.0092 7.00706 11.3446 7.00652 11.7588C7.00598 12.173 7.34133 12.5092 7.75554 12.5098L11.1565 12.5142C11.2117 12.5143 11.2565 12.5591 11.2564 12.6143L11.252 16.0153C11.2514 16.4295 11.5868 16.7657 12.001 16.7663C12.4152 16.7668 12.7514 16.4315 12.752 16.0173L12.7564 12.6163C12.7565 12.5611 12.8013 12.5163 12.8565 12.5164L16.2575 12.5208C16.6717 12.5214 17.0079 12.186 17.0085 11.7718C17.009 11.3576 16.6737 11.0214 16.2594 11.0208L12.8585 11.0164C12.8032 11.0163 12.7585 10.9715 12.7586 10.9163L12.763 7.51531C12.7636 7.1011 12.4282 6.76488 12.014 6.76434C11.5998 6.7638 11.2636 7.09914 11.263 7.51336L11.2586 10.9143C11.2585 10.9696 11.2137 11.0143 11.1585 11.0142L7.7575 11.0098Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEformv2CreateBtn);
export default __webpack_public_path__ + "static/media/eformv2-create-btn.c85724d635f6aef85a60527bf576454b.svg";
export { ForwardRef as ReactComponent };